<template>
  <div class="tableDom">
    <div class="Table">
      <div class="TableItem Table_header displayc">
        <div style="width: 20%">{{ tableTitle[0] }}</div>
        <div style="width: 30%">{{ tableTitle[1] }}</div>
        <div style="width: 20%">{{ tableTitle[2] }}</div>
        <div style="width: 20%">{{ tableTitle[3] }}</div>
        <div style="width: 15%">{{ tableTitle[4] }}</div>
      </div>
      <div style="overflow: hidden; height: 260px">
        <vue3-seamless-scroll
          hover-stop="true"
          v-model="isScrolling"
          :list="RightLeftData"
          :hover="true"
          :step="0.8"
          :class-option="classOption"
          ref="scrollRef"
        >
          <div
            class="TableItem displayc Table_CItem"
            :class="index % 2 !== 0 ? 'Table_CItem' : 'Table_CItemL'"
            v-for="(item, index) in RightLeftData"
            :key="index"
          >
            <!-- <div style="width: 20%">
              <div class="Idstyle">{{ item.id }}</div>
            </div> -->
            <div style="width: 20%" class="displayc">
              <div class="Namestyle">{{ item.name }}</div>
            </div>
            <div style="width: 30%">
              <div class="bgStyle">{{ item.number1 }}</div>
            </div>
            <div style="width: 20%">{{ item.number2 }}</div>
            <div style="width: 20%">
              <span
                :style="{
                  display: 'inline-block',
                  width: '48px',
                  height: '20px',
                  // background: (item.number3 == '0' ? 'green' : item.number3 == '1' ? 'red' : item.number3 == '2' ? '#ffa500' : '#000'),
                  // background: (item.number3 == '0' ? require('../assets/r0.png') : item.number3 == '1' ? require('../assets/r1.png') : item.number3 == '2' ? require('../assets/r2.png') : '#000'),
                  background: getBackgroundStyle(item.number3),
                }"
              >
                {{
                  item.number3 == "0"
                    ? "满意"
                    : item.number3 == "1"
                    ? "不满意"
                    : item.number3 == "2"
                    ? "被投诉"
                    : item.number3
                }}</span
              >
            </div>
            <div style="width: 15%">
              <!-- src="../assets/photo.png" -->
              <!-- @click="playAudio(item.audioUrl)" -->

              <img
                :src="
                  item.isPlaying
                    ? require('../assets/photo2.png')
                    : require('../assets/photo.png')
                "
                alt=""
                @click="toggleAudio(item)"
              />
              <!-- {{ item.value }} -->
            </div>
          </div>
        </vue3-seamless-scroll>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped></style>
<script>
import { defineComponent, ref, nextTick } from "vue";
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";

// 使用 ES6 import 引入图片
import r0 from "../assets/r0.png";
import r1 from "../assets/r1.png";
import r2 from "../assets/r2.png";

export default defineComponent({
  name: "TableM",
  components: { Vue3SeamlessScroll },
  props: {
    list: Array,
    onChangeAnalysisFlag: Function,
  },
  data() {
    return {
      Flag: "",
      classOption: {
        // singleHeight: 0
      },
      goToSchoolTwo: {},
      tableTitle: ["服务对象", "时间", "操作", "结论", "通话记录"],
      RightLeftData: [
        {
          id: 1,
          name: "张三",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 2,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "1",
          value: "",
        },
        {
          id: 3,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "2",
          value: "",
        },
        {
          id: 4,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 5,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 6,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 7,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 8,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 9,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 10,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 11,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 12,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 13,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
        {
          id: 14,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          value: "",
        },
      ],
      currentAudio: null, // 新增：当前正在播放的音频对象
      scrollRef: ref(null), // 新增：滚动组件的引用
      isScrolling: true, // 新增：是否正在滚动
    };
  },

  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        this.RightLeftData = newVal;
      },
      deep: true,
      immediate: true,
    },
    onChangeAnalysisFlag: {
      handler(newVal, oldVal) {
        this.Flag = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
  },
  methods: {
    // 新增方法用于获取背景样式
    getBackgroundStyle(number3) {
      switch (number3) {
        case "0":
          return `url(${r0}) no-repeat center center / cover`;
        case "1":
          return `url(${r1}) no-repeat center center / cover`;
        case "2":
          return `url(${r2}) no-repeat center center / cover`;
        default:
          return "#000";
      }
    },
    // toggleAudio(item) {
    //   if (this.currentAudio && this.currentAudio !== item.audio) {
    //     // 暂停当前正在播放的音频
    //     this.currentAudio.pause();
    //     this.currentAudio = null;
    //     // 重置播放状态
    //     this.RightLeftData.forEach((i) => {
    //       i.isPlaying = false;
    //     });
    //   }

    //   if (item.isPlaying) {
    //     // 暂停当前音频
    //     item.audio.pause();
    //     item.isPlaying = false;
    //   } else {
    //     if (!item.audio) {
    //       // 创建新的音频对象
    //       item.audio = new Audio(item.audioUrl);
    //     }
    //     // 播放音频
    //     item.audio.play();
    //     item.isPlaying = true;
    //     this.currentAudio = item.audio;
    //   }
    // },
    toggleAudio(item) {
      // console.log('item:', item);
      if (this.currentAudio && this.currentAudio !== item.audio) {
        // 暂停当前正在播放的音频
        this.currentAudio.pause();
        this.currentAudio = null;
        // 重置播放状态
        this.RightLeftData.forEach((i) => {
          i.isPlaying = false;
        });
        // 重新开始滚动
        this.isScrolling = true;
      }

      if (item.isPlaying) {
        // 暂停当前音频
        item.audio.pause();
        item.isPlaying = false;
        // 重新开始滚动
        this.isScrolling = true;
      } else {
        if (!item.audio) {
          // 创建新的音频对象
          item.audio = new Audio(item.audioUrl);
        }
        // 播放音频
        item.audio.play();
        item.isPlaying = true;
        this.currentAudio = item.audio;

        // 停止滚动
        this.isScrolling = false;
      }
    },

    playAudio(url) {
      // 新增：如果有正在播放的音频，先暂停并释放
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }
      console.info("播放音频", url);
      const audio = new Audio(url);
      console.log(audio);
      audio.controls = true;
      audio.play();
      this.currentAudio = audio; // 新增：更新当前正在播放的音频对象
    },
  },
});
</script>

<style>
.tableDom {
  width: calc(100% - 30px);
  height: calc(100% - 109px);
  margin: 10px auto 0;
}

.Table {
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
  position: relative;
  height: 100%;
  z-index: 1;
}

.TableItem {
  width: 100%;
  height: 35px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  margin-bottom: 11px;
}

.Table_header {
  width: 100%;
  z-index: 5;
  position: relative;
  background: rgb(23, 23, 55, 1);
}

.Table_header div {
  /* font-family: SourceHanSansCN-Bold, SourceHanSansCN; */
  /* font-weight: bold; */
  /* color: #29EDF7; */
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #30e5f8 !important;
  letter-spacing: 0;
  font-weight: 400;
}

.Table_C {
  width: 100%;
  overflow: hidden;
  /* overflow: scroll; */
  z-index: 1;
  /* transform: translateY(-220px); */
  /* animation: scroll-news10 10s linear infinite; */
}

@keyframes scroll-news10 {
  0% {
    transform: translateY(220px);
  }

  100% {
    transform: translateY(-70%);
  }
}

.Table_CItem {
  z-index: 1;
  position: relative;
  background: rgb(3, 18, 31, 0.35);
  /* background: url(./assets/Table_CItemBg.png) no-repeat center center/ 100% 100%; */
}

.Table_CItemL {
  z-index: 1;
  /* background: url(./assets/Table_CItemLBg.png) no-repeat center center/ 100% 100%; */
}

.TableItem div {
  font-weight: 400;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
}

.Idstyle {
  border-radius: 50%;
  background-color: #65dbee;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold !important;
  font-size: 16px;
  color: #000 !important;
  width: 20px;
  height: 20px;
}

.Namestyle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: 400 !important;
  font-size: 16px;
  height: 32px;
}

.bgStyle {
  width: 68px;
  height: 24px;
  line-height: 24px;
  border-radius: 1px;
  margin: 0 auto;
}

.bgStyleY {
  background: linear-gradient(180deg, #fdff80 0%, #f2d10a 100%);
  border: 1px solid #fdf19d;
}

.bgStyleR {
  background: linear-gradient(180deg, #ff8080 0%, #f20a0a 100%);
  border: 1px solid #ff5c5c;
}

.bgStyleB {
  background: linear-gradient(180deg, #80dfff 0%, #0aacf2 100%);
  border: 1px solid #9db5fd;
}
</style>
